import {
	Component,
	effect,
	EventEmitter,
	Input,
	OnInit,
	Output,
	signal,
	WritableSignal
}                            from '@angular/core';
import { BaseComponent }     from '@core/bases/base-component/base.component';
import { AllowedTabSetEnum } from '@core/interfaces/common.interfaces';
import { TabItemComponent }  from '@shared/components/tabset/component/tab-item/tab-item.component';


@Component( {
	selector: 'app-tabset',
	templateUrl: './tabset.component.html',
	styleUrls: [ './tabset.component.scss' ]
} )

export class TabsetComponent extends BaseComponent implements OnInit {

	private _activeTab: WritableSignal<AllowedTabSetEnum> = signal( null );

	public tabs: WritableSignal<TabItemComponent[]> = signal( [] );

	@Input() hideTabContent = false;
	@Input() hideTabItems = false;
	@Input() showIcon = true;
	@Input() showTitle = true;

	@Input() set activeTab( activeTab: AllowedTabSetEnum ) {
		this._activeTab.set( activeTab );
	}

	get activeTab(): AllowedTabSetEnum {
		return this._activeTab();
	}

	@Output() tabChanged: EventEmitter<string> = new EventEmitter<string>();

	constructor() {
		super();
		effect( () => {
			const tabItemComponentToBeActivated: TabItemComponent = this.getTabItemComponentToBeActivated( this._activeTab() );
			if ( !tabItemComponentToBeActivated?.active ) {
				this.activateTabItem( tabItemComponentToBeActivated );
			}
		} )
	}

	private activateTabItem( tabItem: TabItemComponent ): void {
		if ( !tabItem ) { return; }

		this.tabs().forEach( ( tab: TabItemComponent ) => {
			tab.active = false;
		} );

		tabItem.active = !tabItem.isDisabled();
	}

	private getTabItemComponentToBeActivated( tabItemId: AllowedTabSetEnum ): TabItemComponent {
		return this.tabs().find( ( tabItem: TabItemComponent ) =>
			tabItem.identifier === tabItemId
		);
	}

	ngOnInit(): void {
		this.logger.debug( 'TabsetComponent:ngOnInit' );
	}

	addTab( tab: TabItemComponent ): void {
		tab.active = this.activeTab === tab.identifier;
		this.tabs().push( tab );
	}

	// intended to be called only after initialization on manual product tab change/switch
	selectTab( selectedTab: TabItemComponent ): void {
		if ( !selectedTab || selectedTab.isDisabled() || this.hideTabItems ) { return; }

		this.activateTabItem( selectedTab );

		this._activeTab.set( selectedTab.identifier );
		this.tabChanged.emit( this._activeTab() );
	}
}
